/**
 * Escapes HTML special characters in a string to prevent XSS when interpolating
 * untrusted values into raw HTML strings (e.g. document.write).
 *
 * Characters escaped: & < > " '
 */
export const escapeHtml = (unsafe: string | null | undefined): string => {
    if (unsafe == null || unsafe === '') return '';
    return unsafe
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
};
